export function prettifyTime(time: Date | undefined)
{
    if (!time) return undefined;
    return (time.toLocaleTimeString("en-ZA", { hour: "2-digit", minute: "2-digit" }));
}
